export enum GenericIconTypes {
    OPTIONS = "Options",
    CLOSE = "Close",
    SHARE = "Share",
    LINK = "Link"
}